import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c54c415e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-item active" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "badge-wrapper" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "icon icon-group" }
const _hoisted_9 = { class: "badge-wrapper" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_app_badge = _resolveComponent("app-badge")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { class: "row w-100" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { class: "col" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(["icon", [_ctx.currentPage === _ctx.NAVIGATION_PAGES.HOME ? 'icon-home-active' : 'icon-home']])
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text", {'disabled-text': _ctx.currentPage !== _ctx.NAVIGATION_PAGES.HOME}])
                      }, _toDisplayString(_ctx.$localize('footer.home_tab')), 3)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { class: "col" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_link, { to: "/messages/my" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(["icon", [_ctx.currentPage === _ctx.NAVIGATION_PAGES.MESSAGES_MY ? 'icon-message-circle-active' : 'icon-message-circle']])
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_app_badge, {
                            number: _ctx.mainStore.badgesMessage
                          }, null, 8, ["number"])
                        ])
                      ], 2),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$localize('footer.message_tab')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { class: "col" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, { to: "/drive" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(["icon", [_ctx.isDrive ? 'icon-folder-logo-active' : 'icon-folder-logo']])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$localize('footer.drive_tab')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { class: "col" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/spaces" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_app_badge, { number: _ctx.badgesContactTab }, null, 8, ["number"])
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$localize('footer.contacts_tab')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { class: "col" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, { to: "/settings" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(["icon", [_ctx.currentPage === _ctx.NAVIGATION_PAGES.SETTINGS ? 'icon-settings2-active' : 'icon-settings2']])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$localize('footer.settings_tab')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}